<save-partail-details *ngIf="isPartailsCJ" #partialInfoSaveModel (Save)="savePartailCJContractDetails($event)"></save-partail-details>
<button
  *ngIf="isPartailsCJ"
  id="UI_BtnShowPopUp"
  title="GUARDAR"
  style="width: 150px"
  type="button"
  class="btn solid-main text-09-d-demibold modal-trigger"
  data-trigger-modal="modal-example-call-centre"
  (click)="showPartialCJSaveInfoModal()">
  GUARDAR
</button>

<sw-modify-top></sw-modify-top>

<sw-process-container></sw-process-container>

<div class="col-xs-12 col-sm-1 col-md-2 col-lg-3">
  <button class="btn solid-main update visible-xs visible-sm close" id="btnGetQuotes" (click)="getQuotes()">Actualizar resultados</button>
</div>
